import { cx } from '@linaria/core';
import { labelAboveInput, content, labelOnInput, borderClearer, errorMessage, inputWrapper, modifiers, wrapper } from './atom.input-border.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function InputBorder(props) {
  return /*#__PURE__*/jsxs("label", {
    className: cx(props.className, wrapper),
    id: props.id,
    ref: props.ref,
    children: [props.label && props.labelPosition === "above-input" && /*#__PURE__*/jsx("div", {
      className: labelAboveInput,
      children: props.label
    }), /*#__PURE__*/jsx("div", {
      className: cx(inputWrapper, props.active && modifiers.active.className, !props.value && modifiers.empty.className, props.invalid && modifiers.invalid.className, props.readOnly && modifiers.readOnly.className, props.disabled && modifiers.disabled.className, props.labelPosition === "above-input" && modifiers.labelAbove.className),
      children: /*#__PURE__*/jsxs("div", {
        className: content,
        children: [props.children, (props.label || props.value === "") && /*#__PURE__*/jsx("span", {
          className: labelOnInput,
          children: props.label
        }), props.label && /*#__PURE__*/jsx("span", {
          className: borderClearer,
          "aria-hidden": true,
          children: props.label
        }), /*#__PURE__*/jsx("span", {
          className: cx(errorMessage),
          children: props.errorMessage && `* ${props.errorMessage}`
        })]
      })
    })]
  });
}

export { InputBorder };
//# sourceMappingURL=atom.input-border.js.map
